module.exports = __webpack_public_path__ + "static/demo.5cc95860.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/experience/demo.png
// module id = 473
// module chunks = 35783957827783